import { EmptySelect } from "./EmptySelect";
import { SelectedCard } from "./SelectedCard";
import { useAccountProducts } from "./useAccountProducts";
import { TestId } from "@shared/testIds";
import type { ProductPickerProps } from "./types";

export type { ProductPickerProps, ProductPickerValue } from "./types";

export const ProductPicker = ({ linkId, value, onChange, disabled }: ProductPickerProps) => {
  const list = useAccountProducts(linkId);
  return (
    <div data-testid={TestId.PostToTikTokProductSelect}>
      {value.productId ? (
        <SelectedCard value={value} list={list} disabled={disabled} onChange={onChange} />
      ) : (
        <EmptySelect list={list} disabled={disabled} onChange={onChange} />
      )}
    </div>
  );
};
